/* global localStorage */
import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Helmet } from 'react-helmet'
import marked from 'marked'

const Update = ({ store }) => {
  function reloadPage () {
    store.setLatestVersion()
    window.location.reload()
  }
  const reloadVersion = store.newVersion
  const getMarkdownText = () => {
    const markup = marked(store.getChangelog)
    return { __html: markup }
  }
  if (!store.loggedUser) {
    return store.router.goTo(store.views.login, {}, store)
  }

  return (
    <section className='modal-dialog'>
      <Helmet title={store.__('Update')} />
      <div className='jumbotron'
        style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' }}>
        {reloadVersion &&
          <div>
            <h2>{store.__('New version')}</h2>
            <div className='alert alert-info'>
              <h4>{store.__('New version available!')}</h4>
              {store.__('Your current version:').concat(' ')}
              <strong>{localStorage.getItem('latest_version')}</strong><br />
              {store.__('Latest version is:').concat(' ')}
              <strong>{store.newVersion}</strong>
              <br /><br />
              <button onClick={reloadPage} type='button' className='btn btn-success btn-lg'>
                {store.__('Click here to update')}</button>
              <br /><br /><em>{store.__('By clicking "Click here to update" you confirm that you have read the all-new updates (below in "Release history").')}</em>
            </div><br />
          </div>
        }
        <h2>{store.__('Release history')}</h2>
        { store.getChangelog && <div dangerouslySetInnerHTML={getMarkdownText()} /> }
      </div>
    </section>
  )
}

Update.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(Update))
